import Vue from 'vue';
import App from './App.vue';
import auth from './auth';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueResource from 'vue-resource';
import ResizableColumns from '@spacebnd/vuetify-data-table-resizable-columns';

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(auth);
Vue.use(ResizableColumns);
export default new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
